// Globals
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuProps } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';

// Models
import { ROUTES } from '@/models/router.model';

// Components
import { StyledMainTitleWrapper, StyledPageTitle, StyledPageWrapper } from '../../components/Styled';
import { StyledMenu } from './RegionsAndPickupContainerStyles';

// Modules
import { usePermissions, Resource } from '@/modules/Permissions';

// Helpers
import { RegionsAndPickupTabs, getRegionsAndPickupTabsConfig } from '../../helpers/configs';

const REGIONS_TAB_RESOURCE: Record<string, Resource> = {
  [RegionsAndPickupTabs.REGIONS]: Resource.REGION,
  [RegionsAndPickupTabs.PICKUP]: Resource.PICKUP,
};

const RegionsAndPickupContainer = () => {
  const { t } = useTranslation(['regions']);
  const { canView } = usePermissions();
  const navigate = useNavigate();
  const { tab: defaultTab } = useParams();
  const regionsAndPickupTabsConfig = useMemo(
    () => getRegionsAndPickupTabsConfig(t).filter((tab) => canView(REGIONS_TAB_RESOURCE[tab.key])),
    [canView],
  );
  const selectedKey = useMemo(() => {
    if (defaultTab && regionsAndPickupTabsConfig.some((tab) => tab.key === defaultTab)) {
      return defaultTab;
    }

    return regionsAndPickupTabsConfig.at(0)?.key ?? '';
  }, [defaultTab, regionsAndPickupTabsConfig]);
  const selectedRegionsAndPickupTab = useMemo(
    () => regionsAndPickupTabsConfig.find((item) => item.key === selectedKey),
    [selectedKey, regionsAndPickupTabsConfig],
  );

  const onClick: MenuProps['onClick'] = (e) => {
    navigate(`${ROUTES.REGIONS_AND_PICKUP_INDEX}/${e.key}`);
  };

  return (
    <StyledPageWrapper>
      <StyledMainTitleWrapper>
        <StyledPageTitle>{t('regions_main_title')}</StyledPageTitle>
        <StyledMenu
          mode="horizontal"
          items={regionsAndPickupTabsConfig}
          defaultSelectedKeys={[selectedKey]}
          onClick={onClick}
        />
      </StyledMainTitleWrapper>

      {selectedRegionsAndPickupTab?.content}
    </StyledPageWrapper>
  );
};

export default RegionsAndPickupContainer;
